export default "/images/a491a961272c0e1a3b14586133950e87.avif";